import axios from 'axios'

const auth = {
    async fetchSecretKey(){
        const key = await axios.post('fetch-secret-key', {})
        return key
    },
    async login(email, password) {
        const user = await axios.post('auth/login', {
            email: email,
            password: password,
        })
        console.log('user', user)
        return user
    },
    async customerLogin(email, password) {
        const user = await axios.post('auth/customer-login', {
            email: email,
            password: password,
        })
        console.log('user', user)
        return user
    },

    async changePassword(model) {
        return await axios.put(`auth/change_password`, model)
    },
    async updateCustomerPortal(model){
        return await axios.put(`auth/update_profile`, model)
    },
    async getCustomer(model){
        return await axios.post(`auth/get_customer`, model)
    },
    async getUser(model){
        return await axios.post(`auth/get_user`, model)
    },

    async requestPasswordReset(payload) {
        return await axios.post(`auth/pre_forgot`,
            payload
        )
    },

    async resetPassword(model) {
        return await axios.put(`auth/post_forgot`, model)
    },

    async getOrderData({ order_id, hash, timestamp }) {
        return await axios.get(
            `auth/get_order_data?order_id=${order_id}&hash=${hash}&timestamp=${timestamp}`
        )
    },
    async postOrderCompleted(data) {
        return await axios.post(`auth/post_complete/`, data)
    },
    async uploadProfilePicture(data) {
        return await axios.post(`auth/edit-profile-picture`, data)
    },

    async logout() {
        return await axios.post('auth/logout')
    },
}

export default auth
